import type { OpenApiAssociatedType } from '@/models/openapi.ts'

export const ASSOCIATED_TYPES = [
  'AUTHORITY',
  'SCHEME',
  'SERVICE_USER',
  'DEVICE',
] as const satisfies readonly OpenApiAssociatedType[]

export type AssociatedType = (typeof ASSOCIATED_TYPES)[number]
